import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=40c528b2&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=ts"
export * from "./Gallery.vue?vue&type=script&lang=ts"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=40c528b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c528b2",
  null
  
)

export default component.exports